<template>
  <div id="visit-reports">
    <!-- Page title -->
    <page-title icon="fa fa-calendar-alt" main="Agenda" sub="Book de Visitas" :help="true"
      titleHelp="Ajuda - Book de Visitas"
      content="Ao final de cada ano safra, tenha acesso ao resumo de todas as visitas feitas a um cliente."
    />

    <!-- Filers -->
    <schedule-reports-filter
      v-model="filter"
      with-anosafras
      generate-pdf
      clear-filters
      :loading-pdf="loadingPdf"
      :loading="loadingReport"
      :errors="errors"
      @search="getScheduleReports"
      @generate-pdf="exportPdf"
      @clear-filters="clearFilters"
    />

    <!-- Report list -->
    <div class="card mt-2" style="padding: 1rem">
      <div slot="header" class="align-items-center">
        <div class="col-sm-12 col-md-12">
          <h5 class="h3 mb-0">Book de Visitas</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-4">
            Lista de book de visitas:
          </h6>

          <schedule-report-book-list :schedule-reports="scheduleReports" v-loading="loadingReport" />

          <div slot="footer" class="row justify-content-end mr-1 mt-2">
            <base-pagination
              v-model="paginationParams.page"
              @input="changePage"
              :total="paginationParams.total"
              :per-page="paginationParams.per_page"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PageTitle from "@/layouts/PageTitle";
import ScheduleReportsFilter from "@/components/ScheduleReports/ScheduleReportFilters";
import ScheduleReportBookList from "@/components/ScheduleReports/ScheduleReportBookList";
import axios from "@/backend/axios/index.js";

const filter = ref({
  client_id: null,
  anosafra_id: null,
});

const loadingReport = ref(false);
const scheduleReports = ref([]);

const errors = ref({
  client_id: null,
  anosafra_id: null,
});

const { anosafra, ...paramsToSend } = filter.value;

const getScheduleReports = async () => {
  if (!filter.value.client_id)   return errors.value = { ...errors.value, client_id:    "Campo obrigatório" };
  if (!filter.value.anosafra_id) return errors.value = { ...errors.value, anosafra_id:  "Campo obrigatório" };

  errors.value = {};
  loadingReport.value = true;   
  try {
    const response = await axios.get("/api/v1/schedule_reports", {
      params: {
        q: {
          ...paramsToSend,
          since: new Date().toISOString().split("T")[0],
        },
        per_page: paginationParams.value.per_page,
        page: paginationParams.value.page,
      },
    });

    scheduleReports.value = response.data.schedule_reports || [];
    paginationParams.value = response.data.pagination_params || {};
  } catch (error) {
    console.warn("[VisitReports][getScheduleReports]", error);
  }
  loadingReport.value = false;
};

const paginationParams = ref({
  page: 1,
  total: 0,
  per_page: 10,
});

const loadingPdf = ref(false);
const exportPdf = async () => {
  if (!filter.value.client_id)   return errors.value = { ...errors.value, client_id:    "Campo obrigatório" };
  if (!filter.value.anosafra_id) return errors.value = { ...errors.value, anosafra_id:  "Campo obrigatório" };

  loadingPdf.value = true;
  
  try {
    const response = await axios.get("/api/v1/schedule_reports.pdf", {
      params: {
        q: {
          anosafra_id: filter.value.anosafra_id,
          client_id: filter.value.client_id,
        },
        custom_title: "BOOK DE VISITAS",
      },
      responseType: "arraybuffer",
    });

    // Starting file donwload
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank'
    link.setAttribute('download', 'book-de-visitas.pdf');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.warn("[VisitReports][getScheduleReports]", error);
  }
  loadingPdf.value = false;
};

const changePage = (page) => {
  paginationParams.value.page = page;
  getScheduleReports();
};
const clearFilters = () => {
  filter.value.client_id = null;
  filter.value.anosafra_id = null;
};
</script>
